"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var rule_details_checkbox_1 = require("./rule-details-checkbox");

var RuleDetailsCheckboxGroup = function (_super) {
  __extends(RuleDetailsCheckboxGroup, _super);

  function RuleDetailsCheckboxGroup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderCheckboxes = function () {
      return _this.props.checkboxPropList.map(function (checkbox) {
        return react_1.default.createElement(react_native_1.View, {
          key: checkbox
        }, react_1.default.createElement(rule_details_checkbox_1.RuleDetailsCheckbox, {
          label: checkbox,
          id: checkbox,
          isSelected: _this.props.selectedValues[checkbox],
          onCheckboxClick: _this.props.onCheckboxClick,
          propertyValue: _this.props.selectedValues
        }));
      });
    };

    return _this;
  }

  RuleDetailsCheckboxGroup.prototype.render = function () {
    return react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.generalContainerView
    }, react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.checkboxGroupLabelView
    }, react_1.default.createElement(react_native_1.Text, {
      style: theme_pricing_system_1.pricingStyles.checkboxGroupLabelText
    }, this.props.label)), react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.checkboxGroupContainer
    }, this.renderCheckboxes()));
  };

  return RuleDetailsCheckboxGroup;
}(react_1.default.Component);

exports.RuleDetailsCheckboxGroup = RuleDetailsCheckboxGroup;